import { DEFAULT_CAD_TO_RATES, SUPPORTED_CURRENCIES } from './constants'

export const normalizeCurrency = (currency) => {
  if (!currency) return 'CAD'
  return String(currency).trim().toUpperCase()
}

export const isSupportedCurrency = (currency) => {
  return SUPPORTED_CURRENCIES.includes(normalizeCurrency(currency))
}

export const getCadToCurrencyRate = (rates, currency) => {
  const normalized = normalizeCurrency(currency)
  if (normalized === 'CAD') return 1

  const rateFromPayload = rates?.[normalized]
  if (typeof rateFromPayload === 'number' && Number.isFinite(rateFromPayload) && rateFromPayload > 0) {
    return rateFromPayload
  }

  const fallback = DEFAULT_CAD_TO_RATES[normalized]
  if (typeof fallback === 'number' && Number.isFinite(fallback) && fallback > 0) {
    return fallback
  }

  return 1
}

export const convertCadAmount = (amountCad, currency, rates) => {
  const numeric = Number(amountCad)
  if (!Number.isFinite(numeric)) return null
  const rate = getCadToCurrencyRate(rates, currency)
  return numeric * rate
}

export const convertToCadAmount = (amountInCurrency, currency, rates) => {
  const numeric = Number(amountInCurrency)
  if (!Number.isFinite(numeric)) return null
  const rate = getCadToCurrencyRate(rates, currency)
  if (!Number.isFinite(rate) || rate <= 0) return numeric
  return numeric / rate
}

export const inferCurrencyFromCountry = (countryCode) => {
  const code = String(countryCode || '').trim().toUpperCase()
  const mapping = {
    CA: 'CAD',
    US: 'USD',
    GB: 'GBP',
    AU: 'AUD',
    JP: 'JPY',
    AT: 'EUR',
    BE: 'EUR',
    DE: 'EUR',
    ES: 'EUR',
    FI: 'EUR',
    FR: 'EUR',
    IE: 'EUR',
    IT: 'EUR',
    NL: 'EUR',
    PT: 'EUR',
    GR: 'EUR',
  }
  return mapping[code] || 'CAD'
}
